import { IStand, NotificationType } from "@evennt-tech/api-v2-core";
import { apiV2 } from "api/firebase";
import { RequestKey } from "api/request-key";

export const STANDS_PAGE_SIZE = 50;
export const STANDS_MAX_PAGE_SIZE = 100;

export const STAND_REALTIME_KEYS = [
  NotificationType.CREATED_STAND,
  NotificationType.UPDATED_STAND,
  NotificationType.BULK_UPDATED_STANDS,
  NotificationType.CREATED_EXHIBITOR_PAIR,
  NotificationType.UPDATED_EXHIBITOR_PAIR,
];

export const standsQueryKey = (showId?: string) => [
  RequestKey.GetStandsPaginatedApiV2,
  showId,
];

type FindStandByExactNameArgs = {
  showId: string;
  name: string;
  suffixName: string;
};

export const findStandByExactName = async ({
  showId,
  name,
  suffixName,
}: FindStandByExactNameArgs): Promise<IStand | null> => {
  const { items } = await apiV2.stand.getPaginated({
    showId,
    exactName: name.trim(),
    exactSuffixName: suffixName.trim(),
    limit: 1,
  });

  return items[0] ?? null;
};
